import React from 'react';
import { Text, Box } from '@chakra-ui/react';
import { usePageTitle } from '../context/PageTitleContext';

const PageTitle: React.FC = () => {
  const { pageTitle } = usePageTitle();

  if (!pageTitle.trim()) {
    return null;
  }

  return (
    <Box 
      w="full" 
      textAlign="center" 
      mt={{ base: "-4px", md: "1px" }}
      mb={{ base: "4px", md: "9px" }}
      px={4}
    >
      <Text 
        fontSize={{ base: 'lg', md: '2xl' }}
        fontWeight="bold"
        color="#FED49A"
        textShadow="0 0 10px rgba(254, 212, 154, 0.3)"
        lineHeight="1.2"
        wordBreak="break-word"
      >
        {pageTitle}
      </Text>
    </Box>
  );
};

export default PageTitle;
